<template>
    <div class="groupField_wrap">
        <field
            margin="5px 5px 0 0"
            width="245px"
            label="Driver name"
            placeholder="Enter driver name"
            @updateInput="onInput($event, 'name', item)"
            :setInputValue="item.name"
            :idx="idx"
            is-readonly
        ></field>
        <field
            margin="5px 5px 0"
            width="145px"
            type="text"
            label="Date from"
            placeholder="Enter date from"
            :dateValue="item.date_start"
            @updateDate="onDate($event, item)"
            :idx="idx"
            is-date
        ></field>
        <field
            margin="5px 5px 0"
            width="120px"
            type="number"
            label="Rate amount"
            :idx="idx"
            placeholder="0"
            @updateInput="onInput($event, 'amount', item)"
            :setInputValue="item.amount"
        ></field>
        <button
            class="eldBtn"
            type="button"
            :disabled="!item.status"
            @click="onEldPopup({ item, idx })"
        >ELD
        </button>
        <field
            margin="3px 0 0 0"
            padding="0"
            :labelSwitch="item.status ? 'Active': 'Inactive'"
            :switchValue="!!item.status"
            @updateSwitch="onSwitch($event, item)"
            is-switch
        ></field>
    </div>
</template>

<script>
export default {
	name: "DriversList",
	props: {
		item: Object,
		idx: Number
	},
	methods: {
		onInput(value, key, item) {
			this.$emit('updateInput', value, key, item);
		},
		onDate(value, item) {
			this.$emit('updateDate', value, item);
		},
		onSwitch(value, item) {
			this.$emit('updateSwitch', value, item);
		},
		onEldPopup(obj) {
			this.$emit('updateEldPopup', obj);
		}
	}
};
</script>

<style scoped lang="scss">
.groupField_wrap {
    display: flex;
    margin-bottom: 10px;
}

button.eldBtn {
    color: #fff;
    height: 20px;
    border-radius: 4px;
    background: #4caf50;
    padding: 0 15px;
    margin: 25px 0 0 15px;

    &[disabled="disabled"] {
        background-color: rgba(255, 255, 255, 0.12);
        color: rgba(255, 255, 255, 0.3);
    }
}

[type='button'] {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #19BC38;
}
</style>
